var exports = {
  "Jd": "xa15a2ab7--fc81be--actual",
  "Pf": "xa15a2ab7--fc81be--label",
  "h_": "xa15a2ab7--fc81be--description",
  "nf": "xa15a2ab7--fc81be--link",
};

module.exports = exports;
